import styled from '@emotion/styled'

/**
 * 서울 지도 컨테이너 — 디자인 시안 기준 상하 padding 차등 (top 60 / bottom 24).
 * 서울만 단일 SVG라 다른 시도와 layout 다름.
 */
export const MapBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 60px 20px 24px 20px;
`

export const MapImage = styled.img`
  display: block;
  width: 210px;
  height: auto;
  pointer-events: none;
`

/**
 * 지도 위 중앙에 박힌 시도 이름.
 *
 * left: calc(50% + 4px) — 시각적 무게중심이 지도 SVG의 path 모양상 살짝 좌측에 치우쳐 보여서
 * 라벨을 4px 우측으로 보정 (디자인 검수 피드백).
 */
export const SidoLabel = styled.span`
  position: absolute;
  left: calc(50% + 4px);
  top: 60%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: #1b1c1d;
  pointer-events: none;
`
